import { render, staticRenderFns } from "./SuporteDuvidasForm.vue?vue&type=template&id=2cb22ecd&scoped=true&"
import script from "./SuporteDuvidasForm.vue?vue&type=script&lang=js&"
export * from "./SuporteDuvidasForm.vue?vue&type=script&lang=js&"
import style0 from "./SuporteDuvidasForm.vue?vue&type=style&index=0&id=2cb22ecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb22ecd",
  null
  
)

export default component.exports